import { render, staticRenderFns } from "./LoginWelcome.vue?vue&type=template&id=8505463a&scoped=true&"
var script = {}
import style0 from "./LoginWelcome.vue?vue&type=style&index=0&id=8505463a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8505463a",
  null
  
)

export default component.exports